import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-slate-200 bg-white p-4"
};
const _hoisted_2 = {
  class: "mt-2 w-full text-sm"
};
const _hoisted_3 = {
  class: "py-1.5 pr-2 text-slate-500"
};
const _hoisted_4 = {
  class: "py-1.5 pr-2"
};
const _hoisted_5 = ["onUpdate:modelValue", "onBlur", "onKeydown"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "py-1.5 text-xs text-slate-400"
};
const _hoisted_8 = {
  class: "mt-3 flex items-center justify-between"
};
const _hoisted_9 = ["disabled"];
import { computed, ref, watch } from 'vue';
export default {
  __name: 'ConfirmProfileCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const SOURCE_TEXT = {
      crm_prefill: 'CRM 预填',
      user_submit: '手工填写',
      dialogue: '对话采集',
      derived: '系统推导',
      web_check: '联网核对'
    };
    const rows = ref([]);
    watch(() => props.snapshot, snap => {
      const payload = snap && snap.interrupt_payload || {};
      const profile = payload.profile || {};
      const sources = payload.sources || {};
      rows.value = Object.entries(profile).map(([field, value]) => ({
        field,
        value,
        source: sources[field] || 'user_submit',
        editing: false
      }));
    }, {
      immediate: true
    });
    const changed = computed(() => {
      const out = {};
      const profile = (props.snapshot && props.snapshot.interrupt_payload || {}).profile || {};
      for (const r of rows.value) {
        if (r.value !== profile[r.field]) out[r.field] = r.value;
      }
      return out;
    });
    function sourceText(s) {
      return SOURCE_TEXT[s] || s;
    }
    function confirm() {
      // 协议（collection.py:147-153）：提交修正值即确认；空 values = 全部认可
      emit('resume', {
        values: {
          ...changed.value
        }
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-sm font-semibold text-slate-800"
      }, "请确认企业资质画像", -1)), _createElementVNode("table", _hoisted_2, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.field,
          class: "border-b border-slate-50"
        }, [_createElementVNode("td", _hoisted_3, _toDisplayString(row.field), 1), _createElementVNode("td", _hoisted_4, [row.editing ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          "onUpdate:modelValue": $event => row.value = $event,
          class: "form-input form-control-sm w-40",
          onBlur: $event => row.editing = false,
          onKeydown: _withKeys($event => row.editing = false, ["enter"])
        }, null, 40, _hoisted_5)), [[_vModelText, row.value]]) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "cursor-pointer text-slate-800",
          title: "点击修改",
          onClick: $event => row.editing = true
        }, _toDisplayString(row.value), 9, _hoisted_6))]), _createElementVNode("td", _hoisted_7, _toDisplayString(sourceText(row.source)), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_8, [_cache[0] || (_cache[0] = _createElementVNode("p", {
        class: "text-xs text-slate-400"
      }, "点击值可修改；agent 不支持返回重采", -1)), _createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: __props.pending,
        onClick: confirm
      }, _toDisplayString(__props.pending ? '确认中…' : '确认无误'), 9, _hoisted_9)])]);
    };
  }
};